var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    transform: "rotate(180)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#145685",
    strokeWidth: 2,
    className: "arrow-left-blue_svg__toggle",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6h10M8 2l4 4-4 4"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcKICB3aWR0aD0iMTRweCIKICBoZWlnaHQ9IjEycHgiCiAgdmlld0JveD0iMCAwIDE0IDEyIgogIHZlcnNpb249IjEuMSIKICB0cmFuc2Zvcm09InJvdGF0ZSgxODApIgogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIKPgogICAgPGcKICAgIGlkPSLinIUtRmVhdGhlci0oTmV1dHJhbCkiCiAgICBzdHJva2U9Im5vbmUiCiAgICBzdHJva2Utd2lkdGg9IjEiCiAgICBmaWxsPSJub25lIgogICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIKICA+CiAgICAgICAgPGcKICAgICAgaWQ9IkNvY2twaXQiCiAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNTEuMDAwMDAwLCAtODc0LjAwMDAwMCkiCiAgICAgIHN0cm9rZT0iIzE0NTY4NSIKICAgICAgc3Ryb2tlLXdpZHRoPSIyIgogICAgICBjbGFzcz0idG9nZ2xlIgogICAgPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyLjAwMDAwMCwgODcxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9ImFycm93LXJpZ2h0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDAuMDAwMDAwLCA1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDQgTDEwLDQiIGlkPSJQYXRoIiAvPgogICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aCIgcG9pbnRzPSI3IDAgMTEgNCA3IDgiIC8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgArrowLeftBlue as ReactComponent };